import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { PageFormComponent } from './page-form.component';


/**
 * ページパターン設定画面 ページ情報　モジュール設定クラス
 *
 * @export PageFormComponent
 * @class PageFormComponent
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjInputModule,
  ],
  declarations: [
    PageFormComponent,
  ],
  providers: [
  ],
  exports: [
    PageFormComponent,
  ]
})
export class PageFormModule {
}
